import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Location {
  id?: string
  name: string
  code: string
  address: number
  companyId: string
}

export async function getLocations(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = '',
  fieldsAdditional: any = []
): Promise<any> {
  // fields
  let fields = [
    'sucursals.id',
    'sucursals.code',
    'sucursals.name',
    'sucursals.address',
    'sucursals.is_inactive',
    'sucursals.updated_at'
  ]
  if (fieldsAdditional) {
    const index = fields.indexOf('sucursals.address')
    if (index !== -1) {
      fields.splice(index + 1, 0, ...fieldsAdditional)
    }
  }
  // where's
  const where = ['company_id = :companyId']
  if (search) {
    where.push(
      `CONCAT(sucursals.name, sucursals.code, sucursals.address, sucursals.custom_fields->>'custom:mxPercentageISN', master_concepts.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = [
    "GROUP BY sucursals.custom_fields->>'custom:mxConceptsISN', sucursals.id"
  ]
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? modifier.push(
          `ORDER BY (CASE WHEN sucursals.code ~ '^[0-9]+$' THEN CAST(sucursals.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, sucursals.code ${dataOrder[0]}`
        )
      : modifier.push(`ORDER BY ${dataOrder[1]} ${dataOrder[0]}`)
    : modifier.push(
        "ORDER BY (CASE WHEN sucursals.code ~ '^[0-9]+$' THEN CAST(sucursals.code AS NUMERIC) ELSE NULL END), sucursals.code"
      )
  // result
  const response: any = await getData({
    tables: ['pg_sucursals'],
    fields,
    join: [
      "LEFT JOIN LATERAL jsonb_array_elements_text(sucursals.custom_fields -> 'custom:mxConceptsISN') AS master_id ON TRUE",
      'LEFT JOIN master_concepts on master_id::uuid = master_concepts.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getLocation(id: string): Promise<Location> {
  const data = await getData<any>({
    tables: ['pg_sucursals'],
    fields: [
      'address',
      'code',
      'company_id as companyId',
      'id',
      'name',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createLocation(data: Location): Promise<boolean> {
  const response: any = await http.post('payroll/sucursals', {
    company_id: data.companyId,
    name: data.name,
    code: data.code,
    address: data.address,
    custom_fields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateLocation(
  data: Location,
  id: string
): Promise<boolean> {
  const response: any = await http.put('payroll/sucursals/' + id, {
    company_id: data.companyId,
    name: data.name,
    code: data.code,
    address: data.address,
    custom_fields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteLocation(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/sucursals/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateLocation(
  id: string,
  state: boolean
): Promise<boolean> {
  const response: any = await http.put(`/payroll/sucursals/${id}/enable`, {
    enable: state
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
